import { SprievodnyDokumentDownloadApi } from 'evidencna-aplikacia-web-ts-axios';
import { AxiosRequestConfig } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { evidenciaPrefixPath } from '../configuration/apiConfigurationConstants';
import Uuid from '../../model/Uuid';
import { ClientResponse } from '../../model/ClientResponse';
import { getFileName } from '../exportClient';
import DownloadFromStadiumEnum from '../../model/downloadFromStadiumEnum';
import mapDownloadFromStadiumEnum from '../../function/mapDownloadFromStadiumEnum';

const client = new SprievodnyDokumentDownloadApi(apiConfiguration(evidenciaPrefixPath));

interface ResponseType {
  fileName: string;
  blob: Blob;
}

// eslint-disable-next-line import/prefer-default-export
export const downloadSprievodnyDokument = async (
  materialUuid: Uuid,
  sprievodnyDokumentKod: string,
  // eslint-disable-next-line default-param-last
  fromStadium = DownloadFromStadiumEnum.CURRENT,
  options?: AxiosRequestConfig,
): Promise<ClientResponse<ResponseType>> => {
  const {
    data,
    status,
    headers,
  } = await client.downloadSprievodnyDokumentByTyp(
    materialUuid,
    sprievodnyDokumentKod,
    mapDownloadFromStadiumEnum(fromStadium),
    {
      ...options,
      responseType: 'blob',
    },
  );
  const blob = data && new Blob([data]);
  const fileName = getFileName(headers);
  return {
    data: {
      fileName,
      blob,
    },
    responseCode: status,
  };
};
